import { render } from "./TopicExtrato.vue?vue&type=template&id=1dfb40fc"
import script from "./TopicExtrato.vue?vue&type=script&lang=js"
export * from "./TopicExtrato.vue?vue&type=script&lang=js"
script.render = render

export default script